import script from "./CreditCalculatorLemonza.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditCalculatorLemonza.vue?vue&type=script&setup=true&lang=js"

import "./CreditCalculatorLemonza.vue?vue&type=style&index=0&id=064635fc&lang=css"

const __exports__ = script;

export default __exports__